export const ITALIAN_RENEWAL_STATUSES = ["complete", "canceled"] as const;
export type ItalianRenewalStatus = (typeof ITALIAN_RENEWAL_STATUSES)[number];

export const QUIERE_RENOVAR_VALUES = ["yes", "no", "maybe", "no_response"] as const;
export type QuiereRenovar = (typeof QUIERE_RENOVAR_VALUES)[number];

export type ItalianRenewalRow = {
  leadId: number;
  leadUlid: string;
  customer: string;
  email: string;
  policyNumber: string | null;
  renewalYear: number;
  polizaYear: string;
  status: ItalianRenewalStatus;
  renewalDate: string | null;
  renewalEmailSentAt: string | null;
  renewalAcceptanceAt: string | null;
  renewalConfirmationSentAt: string | null;
  daysUntilAcceptance: number | null;
  renewalMonthlyPrice: number | null;
  renewalYearlyPrice: number | null;
  subscriptionStatus: string | null;
  firstInvoicePaid: boolean | null;
  renewalSucceeded: boolean;
  limitRenewalDate: string | null;
  quiereRenovar: QuiereRenovar | null;
  contactoMariana: string | null;
};
